import axios from 'axios';

export const ibooking = {
    getIBooking(projectId) {
      return axios({
        method: 'get',
        url: `https://i-booking-btn-api.myorigin.net/units/by-project?projectId=${projectId}`,
      })
      .then(res => res.data)
      .catch(() => false);
    }
  };
  